import { useIntl } from "react-intl";
import {
  AvailableLanguageOnApp,
  LangCompleteData,
  LangObject,
  LanguageTranslationsKeys,
  LocalesDict,
} from "./types/i18n.types";
import { useEffect, useState } from "react";
import { checkLangLocaleStorage } from "./i18n.service";

export const useTranslation = () => {
  const Intl = useIntl();

  return {
    t: (idTranslation: keyof LanguageTranslationsKeys, defaultString: string) =>
      Intl.formatMessage({
        id: idTranslation,
        defaultMessage: defaultString,
      }),
  };
};

export const useBootLanguageApp = (
  langInApp: LangCompleteData,
  langHeaders: AvailableLanguageOnApp
): {
  appCurrentLang: LangObject;
  handleSetContextCurrentLang: (currentLang: LangObject) => void;
} => {
  const [appCurrentLang, setAppCurrentLang] = useState<LangObject>(
    langInApp[langHeaders]
  );

  const handleSetContextCurrentLang = (currentLang: LangObject) => {
    if (Object.keys(langInApp).includes(currentLang?.locale)) {
      setAppCurrentLang(currentLang);
    } else {
      setAppCurrentLang(langInApp[LocalesDict.ENGLISH_US]);
    }
  };

  useEffect(() => {
    // App Language initialization
    // Comparing lang in header VS lang in localStorage
    let appInitialLocale = checkLangLocaleStorage(langInApp, langHeaders);

    if (appInitialLocale.locale !== langHeaders) {
      setAppCurrentLang(langInApp[appInitialLocale.locale]);
    }
  }, []);

  return {
    appCurrentLang,
    handleSetContextCurrentLang,
  };
};
